import * as React from 'react';
import Styled from 'styled-components';

const SelectOption = Styled.option`
  color: #000;
`;

interface ISelectOptionItemProps {
  optionProps?: React.OptionHTMLAttributes<HTMLOptionElement>;
  value: string;
}

const SelectOptionItem: React.FC<ISelectOptionItemProps> = ({ children, optionProps, value }) => (
  <SelectOption
    {...optionProps}
    value={value}
  >
    {children}
  </SelectOption>
);

SelectOptionItem.displayName = 'SelectOptionItem';

export default SelectOptionItem;
